import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Wine, ArrowLeft, Building2, Users, Clock, Shield, Check } from "lucide-react";
import { api } from "@/lib/api";

const SecretSantaOffice = () => {
  const [guide, setGuide] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/business/secret-santa-office").then((r) => {
      setGuide(r.data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const planUrl = `/for-teams?party=${guide?.cta_business_party || "christmas"}`;

  return (
    <div className="grain min-h-screen relative" data-testid="secret-santa-office-page">
      <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-[#0a0908]/80 border-b border-[#2d2424]">
        <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-display text-xl tracking-wide">
            <Wine size={18} className="text-[#8b0000]" />
            <span>wasntme<span className="text-[#8b0000]">.party</span></span>
          </Link>
          <Link to="/for-teams" className="btn-ghost text-sm" data-testid="back-to-teams">
            <ArrowLeft size={14} /> Back to For Teams
          </Link>
        </div>
      </nav>

      <section className="pt-32 pb-12">
        <div className="max-w-4xl mx-auto px-6">
          <div className="font-hand text-[#d4af37] text-2xl rotate-[-2deg] mb-3">team file #T02 · large-group variant</div>
          <h1 className="font-display text-5xl sm:text-6xl font-bold leading-[0.95] tracking-tight max-w-3xl">
            {guide?.title || "Secret Santa Showdown — Office Edition"}
          </h1>
          {guide && (
            <p className="mt-4 text-lg text-[#a39797] max-w-2xl leading-relaxed">
              {guide.subtitle}. For {guide.sizes}. Runs {guide.run_time}. {guide.format}.
            </p>
          )}
          <div className="mt-8 flex flex-wrap gap-4">
            <Link to={planUrl} className="btn-primary" data-testid="plan-event-cta">
              <Building2 size={18} /> {guide?.cta_button_label || "Plan this event"}
            </Link>
            <Link to="/for-teams" className="btn-ghost text-sm">
              See all team cases
            </Link>
          </div>
        </div>
      </section>

      {loading && (
        <div className="max-w-4xl mx-auto px-6 py-20 text-center text-[#a39797]">Loading guide…</div>
      )}

      {guide && (
        <>
          <section className="py-10 border-t border-[#2d2424]">
            <div className="max-w-4xl mx-auto px-6">
              <p className="text-lg text-[#f4f0ec] leading-relaxed">{guide.intro}</p>
            </div>
          </section>

          <section className="py-6">
            <div className="max-w-4xl mx-auto px-6 grid md:grid-cols-3 gap-4" data-testid="office-stats">
              <div className="card-noir p-5 flex items-start gap-3">
                <Users size={20} className="text-[#d4af37] mt-1" />
                <div><div className="text-xs text-[#a39797]">GROUP SIZE</div><div className="font-display text-lg">{guide.sizes}</div></div>
              </div>
              <div className="card-noir p-5 flex items-start gap-3">
                <Clock size={20} className="text-[#d4af37] mt-1" />
                <div><div className="text-xs text-[#a39797]">RUN TIME</div><div className="font-display text-lg">{guide.run_time}</div></div>
              </div>
              <div className="card-noir p-5 flex items-start gap-3">
                <Shield size={20} className="text-[#d4af37] mt-1" />
                <div><div className="text-xs text-[#a39797]">TONE</div><div className="font-display text-lg">Safe for work</div></div>
              </div>
            </div>
          </section>

          {guide.sections.map((s, i) => (
            <section key={i} className="py-10 border-t border-[#2d2424]" data-testid={`guide-section-${i}`}>
              <div className="max-w-4xl mx-auto px-6">
                <h2 className="font-display text-3xl mb-6">{s.heading}</h2>
                <ul className="space-y-3">
                  {s.body.map((line, j) => (
                    <li key={j} className="flex items-start gap-3 text-[#f4f0ec] leading-relaxed">
                      <Check size={16} className="text-[#d4af37] mt-1 flex-shrink-0" />
                      <span>{line}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </section>
          ))}

          <section className="py-16 border-t border-[#2d2424]">
            <div className="max-w-3xl mx-auto px-6 text-center">
              <div className="font-hand text-[#d4af37] rotate-[-1deg] text-xl mb-3">ready to book</div>
              <h2 className="font-display text-4xl mb-4">{guide.cta_text}</h2>
              <p className="text-[#a39797] mb-6">Starts at $249 Starter. Company package (up to 150 people): $1,499. Larger: request a quote.</p>
              <Link to={planUrl} className="btn-primary" data-testid="footer-plan-cta">
                <Building2 size={18} /> {guide.cta_button_label}
              </Link>
            </div>
          </section>
        </>
      )}

      <footer className="border-t border-[#2d2424] py-10 text-center text-sm text-[#a39797]">
        <div className="font-display text-2xl text-[#f4f0ec]">wasntme<span className="text-[#8b0000]">.party</span></div>
        <div className="mt-1 text-xs tracking-[0.2em] text-[#d4af37]">A NIGHTBLOOD CHRONICLES PRODUCTION</div>
      </footer>
    </div>
  );
};

export default SecretSantaOffice;
